import { render, staticRenderFns } from "./ElementAttribute.vue?vue&type=template&id=e189ab84&"
import script from "./ElementAttribute.vue?vue&type=script&lang=js&"
export * from "./ElementAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ElementAttribute.vue?vue&type=style&index=0&id=e189ab84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports